import MaterialTable from 'material-table'
import React, { useEffect, useRef, useState } from 'react'
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from "@material-ui/core/styles";
import CliniqueService from '../../services/CliniqueService'
import { toast } from "react-toastify";
import { Grid, Button, Container, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel, Switch } from '@material-ui/core'
import { TextField } from '@material-ui/core'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete } from "@material-ui/lab";
import ProduitVenduService from '../../services/ProduitVenduService';

import { Modal } from "antd";
import { useReactToPrint } from 'react-to-print';
import './styles.css'
import moment from 'moment'

// Variables d'environnement pour le feature flipping
const FEATURE_TVA_ENABLED = process.env.REACT_APP_FEATURE_FLIPPING_TVA === 'true';

const useVenteStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

const VendreProduits = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [prodVenduPending, setProdVenduPending] = useState([])
  const [exportData, setExportData] = useState([]);
  const [reportPrVendu, setReportPrVendu] = useState([]);

  const [formes, setFormes] = useState([])
  const [prod, setProd] = useState('')
  const [famille, setFamille] = useState([])
  const [prix, setPrix] = useState(0)
  const [codeBarre, setCodeBarre] = useState([])
  const [total, setTotal] = useState(0)

  const [modePayement, setModePayement] = useState('ESPECE');
  const [valueRemise, setValueRemise] = useState('0');
  const [montant, setMontant] = useState(0);
  const [montantVerse, setMontantVerse] = useState(0);
  const [donne, setDonne] = useState(0);
  const [dernierRendu, setDernierRendu] = useState(0);
  const [produit, setProduit] = useState([]);
  const [allProduct, setAllProduct] = useState([])

  const componentRef = useRef();
  const refPrint = useRef();

  const [printBillModalVisibility, setPrintBillModalVisibilty] = useState(false);
  const [valider, setValider] = useState(false);

  const options = ['ESPECE', 'WAVE','OM'];
  const remises = ['0', '5','10','15','20'];
  const [value, setValue] = useState(options[0]);
  const [getRemise, setGetRemise] = useState(total);

  // État pour le mode d'ajout
  const [ajoutAuto, setAjoutAuto] = useState(false);

  // État pour la TVA - par défaut false
  const [tvaEnabled, setTvaEnabled] = useState(true);

  // États pour le formulaire de produit
  const [produitForm, setProduitForm] = useState({
    codeBarre: '',
    nomProd: '',
    qtVdu: 1,
    prixProd: 0
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [produitsResponse, famillesResponse, formesResponse, codeBarreResponse] = await Promise.all([
          CliniqueService.getAllProduitDistincts(),
          CliniqueService.getFamilles(),
          CliniqueService.getFormePharmaceutiques(),
          CliniqueService.getAllProductCodeBarre()
        ]);

        setAllProduct(produitsResponse.data)
        setFamille(famillesResponse.data)
        setFormes(formesResponse.data)
        setCodeBarre(codeBarreResponse.data)
        
        await refreshProdVendus();
        
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();
  }, [dispatch])

  const handleCodeBarre = async (value) => {
    try {
      const response = await CliniqueService.getCodeBarre(value);
      const data = response.data;
      if (data && data.length > 0) {
        const selectedProduct = data[0];
        setProd(selectedProduct.nomProd);
        setPrix(selectedProduct.prixProd);
        
        setProduitForm(prev => ({
          ...prev,
          nomProd: selectedProduct.nomProd,
          prixProd: selectedProduct.prixProd,
          codeBarre: value
        }));
        
        if (ajoutAuto) {
          await addProductAutomatically(selectedProduct.nomProd, selectedProduct.prixProd, value, produitForm.qtVdu);
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Produit non trouvé", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  const handleChangeValue = async (value) => {
    try {
      const response = await CliniqueService.getNomProd(value);
      const data = response.data;
      if (data && data.length > 0) {
        const selectedProduct = data[0];
        setPrix(selectedProduct.prixProd);
        setProd(value);
        
        let produitCodeBarre = '';
        try {
          const codeBarreResponse = await CliniqueService.getCodeBarreByNomProd(value);
          const codeBarreData = codeBarreResponse.data;
          produitCodeBarre = codeBarreData && codeBarreData.length > 0 ? codeBarreData[0].codeBarre : '';
        } catch (error) {
          console.log("Erreur récupération code-barre:", error);
          produitCodeBarre = '';
        }

        setProduitForm(prev => ({
          ...prev,
          nomProd: value,
          prixProd: selectedProduct.prixProd,
          codeBarre: produitCodeBarre
        }));
        
        if (ajoutAuto) {
          await addProductAutomatically(value, selectedProduct.prixProd, produitCodeBarre, produitForm.qtVdu);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const addProductAutomatically = async (nomProd, prixProd, codeBarre = '', quantite = 1) => {
    const dateAvecHeure = moment().format("YYYY-MM-DD HH:mm:ss");
    const produit = {
      "codeBarre": codeBarre,
      "prixProdVendu": prixProd,
      "nomProd": nomProd,
      "dateInsert": dateAvecHeure,
      "qtVdu": quantite,
      "speudo": auth.nom,
      "mode_payement": modePayement
    }

    try {
      const response = await ProduitVenduService.saveProdVendu(produit);
      
      if (response.data.message === "Produit insuffisant dans le stock") {
        toast.error("Produit Insuffisant dans le stock...", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        toast.success("Produit ajouté avec succès...", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        await refreshProdVendus();
        await refreshProdExport();
        resetProduitForm();
      }
      
    } catch (error) {
      console.log("Erreur lors de l'ajout du produit:", error);
      toast.error(error.response?.data?.message || "Erreur lors de l'ajout du produit", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  const resetProduitForm = () => {
    setProduitForm({
      codeBarre: '',
      nomProd: '',
      qtVdu: 1,
      prixProd: 0
    });
    setProd('');
    setPrix(0);
  }

  const onSubmitProduit = async (e) => {
    e.preventDefault();
    
    if (!produitForm.nomProd) {
      toast.error("Veuillez sélectionner un produit", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (produitForm.prixProd <= 0) {
      toast.error("Le prix doit être supérieur à 0", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (produitForm.qtVdu <= 0) {
      toast.error("La quantité doit être supérieure à 0", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    await addProductAutomatically(
      produitForm.nomProd, 
      produitForm.prixProd, 
      produitForm.codeBarre, 
      produitForm.qtVdu
    );
  }

  const refreshProdExport = async () => {
    try {
      const response = await CliniqueService.getProdReport();
      setExportData(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const refreshProdVendus = async () => {
    try {
      const response = await CliniqueService.getProdVenduPending();
      setProdVenduPending(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const paperStyle = { padding: '0 15px 40px 15px', width: 500, height: 1200 }
  const btnStyle = { 
    marginTop: 2, 
    width: '100%',
    height: '90%',
    fontSize: '25px',
    background: '#f26522',
    color: 'white' 
  }

  const initialVentes = {
    mode: 'ESPECE',
    donne: '',
    nom: '',
    remise: "0"
  }

  const validationSchemaVente = Yup.object().shape({
    mode: Yup.string(),
    donne: Yup.number(),
    nom: Yup.string(),
    remise: Yup.string()
  })

  const classes = useVenteStyles();

  const clearPendingProducts = () => {
    setProdVenduPending([]);
    setTotal(0);
    setGetRemise(0);
    setMontant(0);
    setDonne(0);
  };

  const handleDirectPrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      setPrintBillModalVisibilty(false);
    }
  });

  useEffect(() => {
    if (printBillModalVisibility && componentRef.current) {
      const timer = setTimeout(() => {
        handleDirectPrint();
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [printBillModalVisibility, handleDirectPrint]);

  const onSubmitVente = async (values, props) => {
    if (total === 0) {
      toast.error("Il n'y a pas de produits en cours", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const produit = [];
    let depense = {};

    // Calculer le montant après remise
    const montantApresRemise = getRemise !== 0 ? getRemise : total;
    let montantFinal = montantApresRemise;
    
    // Appliquer la TVA si activée
    if (FEATURE_TVA_ENABLED && tvaEnabled) {
      const tauxTVA = values.mode === 'ESPECE' ? 0.01 : 0.005;
      const montantTVA = montantApresRemise * tauxTVA;
      montantFinal = montantApresRemise + montantTVA;
    }

    if (values.mode === 'ESPECE') {
      if (values.donne < montantFinal) {
        toast.error(`La valeur saisie est insuffisante. Minimum requis: ${montantFinal.toLocaleString()} F CFA`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }

      depense = {
        "donne": values.donne,
        "nom": values.nom,
        "mode": values.mode,
        "remise": values.remise,
        "tva_enabled": tvaEnabled ? 1 : 0
      }

      setMontant(depense.donne - montantFinal);
      setMontantVerse(parseFloat(values.donne));
      setDonne(depense.donne);

      setDernierRendu(depense.donne - montantFinal);


      prodVenduPending.forEach((product) => {
        product.donne = depense.donne;
        product.rendu = depense.donne - montantFinal;
        product.nom = depense.nom;
        product.mode = depense.mode;
        product.remise = depense.remise;
        product.tva_enabled = tvaEnabled ? 1 : 0;
        if (tvaEnabled) {
          const tauxTVA = values.mode === 'ESPECE' ? 0.01 : 0.005;
          product.tva_montant = (product.prixProdVendu * product.qtVdu) * tauxTVA;
          product.tva_taux = tauxTVA * 100;
        }
        produit.push(product);
      });
    } else {
      depense = {
        "donne": montantFinal,
        "nom": values.nom,
        "mode": values.mode,
        "remise": values.remise,
        "tva_enabled": tvaEnabled ? 1 : 0
      }

      setMontant(depense.donne - montantFinal);
      setDonne(depense.donne);
      setDernierRendu(0);

      prodVenduPending.forEach((product) => {
        product.donne = depense.donne;
        product.rendu = depense.donne - montantFinal;
        product.nom = depense.nom;
        product.mode_payement = depense.mode;
        product.remise = depense.remise;
        product.tva_enabled = tvaEnabled ? 1 : 0;
        if (tvaEnabled) {
          const tauxTVA = values.mode === 'ESPECE' ? 0.01 : 0.005;
          product.tva_montant = (product.prixProdVendu * product.qtVdu) * tauxTVA;
          product.tva_taux = tauxTVA * 100;
        }
        produit.push(product);
      });
    }

    try {
      const response = await CliniqueService.vendreProduit({"prdVendus": produit});
      toast.success("Vos produits sont bien vendus avec succès...", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      console.log("Réponse complète:", response.data);

      let produitsVendus = [];
      if (response.data && Array.isArray(response.data.produits)) {
        produitsVendus = response.data.produits;
      } else if (Array.isArray(response.data)) {
        produitsVendus = response.data;
      } else if (response.data && typeof response.data === 'object') {
        produitsVendus = [response.data];
      } else {
        produitsVendus = produit;
      }

      setReportPrVendu(produitsVendus);
      console.log("Produits à afficher:", produitsVendus);

      setPrintBillModalVisibilty(true);
      clearPendingProducts();
      await refreshProdVendus();
      props.resetForm();
    // Réinitialiser manuellement les champs importants
      setModePayement('ESPECE'); 
      setValueRemise('0'); 
      setMontant(0); 
      setDonne(0); 
    
      
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }

  const renderVente = () => {
    return (
      <div>
        <Formik 
          initialValues={initialVentes} 
          validationSchema={validationSchemaVente} 
          onSubmit={onSubmitVente}
        >
          {(props) => (
            <Form className={classes.root} style={{display: 'flex', flexDirection: 'row'}} noValidate>
              <Grid item xs={4}>
                <Autocomplete
                  id="mode"
                  name="mode"
                  value={props.values.mode}
                  options={options}
                  onChange={(e, v) => {
                    props.setFieldValue("mode", v);
                    setModePayement(v);
                  }}
                  renderInput={params => (
                    <Field 
                      as={TextField} 
                      {...params} 
                      name="mode" 
                      label="Type payement" 
                      variant="outlined" 
                      fullWidth
                      error={props.errors.mode && props.touched.mode}
                      helperText={<ErrorMessage name='mode' />}  
                      required
                    />
                  )}
                />
              </Grid>
              
              {modePayement === 'ESPECE' ? (
                <>
                  <Grid item xs={4}>
                    <Field 
                      as={TextField} 
                      name='nom' 
                      label='Nom client' 
                      fullWidth 
                      variant="outlined"
                      error={props.errors.nom && props.touched.nom}
                      helperText={<ErrorMessage name='nom' />} 
                      required
                      value={props.values.nom}
                      onChange={(e) => {
                        props.setFieldValue("nom", e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field 
                      as={TextField} 
                      name='donne' 
                      label='Montant donné' 
                      fullWidth 
                      variant="outlined"
                      error={props.errors.donne && props.touched.donne}
                      helperText={<ErrorMessage name='donne' />} 
                      required 
                      value={props.values.donne}
                      onChange={(e) => {
                        props.setFieldValue("donne", e.target.value);
                      }}
                    />
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={4}>
                    <Field 
                      as={TextField} 
                      name='nom' 
                      label='Nom client' 
                      fullWidth 
                      variant="outlined"
                      error={props.errors.nom && props.touched.nom}
                      helperText={<ErrorMessage name='nom' />} 
                      required 
                      value={props.values.nom}
                      onChange={(e) => {
                        props.setFieldValue("nom", e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Field 
                      as={TextField} 
                      name="donne" 
                      placeholder='Montant donné' 
                      fullWidth 
                      variant="outlined"
                      error={props.errors.donne && props.touched.donne}
                      helperText={<ErrorMessage name='donne' />} 
                      required   
                      value={FEATURE_TVA_ENABLED && tvaEnabled ? 
                        (getRemise !== 0 ? getRemise : total) * (1 + (modePayement === 'ESPECE' ? 0.01 : 0.005)) :
                        (getRemise !== 0 ? getRemise : total)
                      }
                      disabled
                    />
                  </Grid>
                </>
              )}
              
              <Grid item xs={4}>
                <Autocomplete
                  id="remise"
                  name="remise"
                  value={props.values.remise}
                  options={remises}
                  onChange={(e, v) => {
                    if (v === '0') {
                      setGetRemise(total);
                    } else {
                      const calcRemise = total * (1 - (v/100));
                      setGetRemise(calcRemise);
                    }
                    props.setFieldValue("remise", v);
                    setValueRemise(v);
                  }}
                  renderInput={params => (
                    <Field 
                      as={TextField} 
                      {...params} 
                      name="remise" 
                      label="Remise" 
                      variant="outlined" 
                      fullWidth
                      error={props.errors.remise && props.touched.remise}
                      helperText={<ErrorMessage name='remise' />}  
                      required
                    />
                  )}
                />
              </Grid>
              
              <Grid item xs={4}>
                <Button 
                  type='submit'  
                  style={btnStyle} 
                  variant='contained'
                  color='primary'
                >
                  Vendre
                </Button>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  useEffect(() => {
    refreshSum();
  }, [prodVenduPending])

  // const refreshSum = () => {
  //   const sum = prodVenduPending.reduce(function (result, item) {
  //     return result + (item.total || 0);
  //   }, 0);
  //   setTotal(sum);
  //   if (valueRemise === '0') {
  //     setGetRemise(sum);
  //   }
  // }
  const refreshSum = () => {
    const sum = prodVenduPending.reduce((total, item) => {
      // Calculer le total pour chaque produit : prix × quantité
      const produitTotal = (item.prixProdVendu || 0) * (item.qtVdu || 1);
      return total + produitTotal;
    }, 0);
    
    setTotal(sum);
    if (valueRemise === '0') {
      setGetRemise(sum);
    }
  };

  const columns = [
    {
      title: "PRODUIT", 
      field: "nomProd"
    },
    { 
      title: "PRIX PRODUIT", 
      field: "prixProdVendu",
      filterPlaceholder: "filter"
    },
    { 
      title: "QUANTITE VENDUE", 
      field: "qtVdu",
      filterPlaceholder: "filter"
    },
    { 
      title: "PAYEMENT", 
      field: "mode_payement",
      filterPlaceholder: "filter"
    },
  ]

  return (
    <>
      {<div style={{display: 'flex', flexDirection: 'column'}}>
        {/* BOUTON TOGGLE TVA */}
        {FEATURE_TVA_ENABLED && <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          padding: '15px',
          backgroundColor: tvaEnabled ? '#e8f5e9' : '#fff3cd',
          borderRadius: '10px',
          border: `2px solid ${tvaEnabled ? '#4caf50' : '#ffc107'}`,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              backgroundColor: tvaEnabled ? '#4caf50' : '#ffc107',
              animation: tvaEnabled ? 'pulse 2s infinite' : 'none'
            }}></div>
            <div>
              <div style={{ fontWeight: 'bold', fontSize: '18px', color: tvaEnabled ? '#2e7d32' : '#ff9800' }}>
                {tvaEnabled ? '✅ SYSTÈME TVA ACTIVÉ' : '⚠️ SYSTÈME TVA DÉSACTIVÉ'}
              </div>
              <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                {tvaEnabled 
                  ? `Taux appliqués: Espèces 1% | Mobile Money/OM 0.5%`
                  : 'Les prix affichés sont hors taxes - Aucune TVA appliquée'}
              </div>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <div style={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: tvaEnabled ? '#2e7d32' : '#666'
            }}>
              {tvaEnabled ? 'ACTIVÉ' : 'DÉSACTIVÉ'}
            </div>
            <Switch
              checked={tvaEnabled}
              onChange={() => setTvaEnabled(!tvaEnabled)}
              color="primary"
              size="medium"
              style={{
                transform: 'scale(1.2)'
              }}
            />
          </div>
        </div>}

        <div style={{display: 'flex', flexDirection: 'column'}}>
          {renderVente()}
          
          {/* SECTION INFOS TVA OU SANS TVA */}
          <div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', flexWrap: 'wrap', marginTop: '15px'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <h1 style={{margin: '5px 0', color: '#017679', fontSize: '18px'}}> 
                Total: {total.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
              </h1>
            </div>
            
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <h1 style={{margin: '5px 0', color: 'gray', fontSize: '18px'}}> 
                Total avec Remise: {getRemise.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
              </h1>
            </div>
            
            {/* Afficher les infos TVA seulement si activée */}
            {FEATURE_TVA_ENABLED && tvaEnabled && (
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div style={{
                  padding: '12px 20px',
                  borderRadius: '8px',
                  background: modePayement === 'ESPECE' ? '#e8f5e9' : '#e3f2fd',
                  border: `2px solid ${modePayement === 'ESPECE' ? '#4caf50' : '#2196f3'}`,
                  textAlign: 'center',
                  minWidth: '250px'
                }}>
                  <div style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '8px'}}>
                    TVA {modePayement === 'ESPECE' ? '1%' : '0.5%'} 
                    <span style={{
                      fontSize: '14px',
                      padding: '4px 10px',
                      borderRadius: '4px',
                      background: modePayement === 'ESPECE' ? '#4caf50' : '#2196f3',
                      color: 'white',
                      marginLeft: '10px'
                    }}>
                      {modePayement}
                    </span>
                  </div>
                  
                  <div style={{fontSize: '16px', fontWeight: 'bold', color: modePayement === 'ESPECE' ? '#2e7d32' : '#1565c0'}}>
                    Montant TVA: {(() => {
                      const montantBase = getRemise !== 0 ? getRemise : total;
                      const tauxTVA = modePayement === 'ESPECE' ? 0.01 : 0.005;
                      const montantTVA = montantBase * tauxTVA;
                      return montantTVA.toLocaleString(undefined, {maximumFractionDigits:2});
                    })()} F CFA
                  </div>
                  
                  <div style={{fontSize: '18px', fontWeight: 'bold', marginTop: '8px', color: '#ff5722'}}>
                    Total TTC: {(() => {
                      const montantBase = getRemise !== 0 ? getRemise : total;
                      const tauxTVA = modePayement === 'ESPECE' ? 0.01 : 0.005;
                      const montantTVA = montantBase * tauxTVA;
                      const totalAvecTVA = montantBase + montantTVA;
                      return totalAvecTVA.toLocaleString(undefined, {maximumFractionDigits:2});
                    })()} F CFA
                  </div>
                </div>
              </div>
            )}
            
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <h1 style={{margin: '5px 0', color: '#F04358', fontSize: '18px'}}> 
                Rendu: {montant.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
              </h1>
              {dernierRendu > 0 && (
                <div style={{
                  marginTop: '5px',
                  padding: '8px 15px',
                  backgroundColor: '#e3f2fd',
                  borderRadius: '20px',
                  border: '1px solid #2196f3',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  <span style={{
                    fontSize: '14px',
                    color: '#1976d2',
                    fontWeight: '500'
                  }}>
                    Dernière monnaie rendue:
                  </span>
                  <span style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#0d47a1',
                    backgroundColor: 'white',
                    padding: '4px 12px',
                    borderRadius: '15px',
                    border: '1px solid #90caf9'
                  }}>
                    {dernierRendu.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                  </span>                  
                </div>
              )}
            </div>
          </div>
        </div>
        
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Container maxWidth="md">
              <FormControl component="fieldset" style={{ marginBottom: '20px', width: '100%' }}>
                <FormLabel component="legend">Mode d'ajout des produits</FormLabel>
                <RadioGroup 
                  row 
                  value={ajoutAuto} 
                  onChange={(e) => setAjoutAuto(e.target.value === 'true')}
                >
                  <FormControlLabel 
                    value={false} 
                    control={<Radio />} 
                    label="Ajout manuel" 
                  />
                  <FormControlLabel 
                    value={true} 
                    control={<Radio />} 
                    label="Ajout automatique" 
                  />
                </RadioGroup>
              </FormControl>

              <form onSubmit={onSubmitProduit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      id="nomProd"
                      options={allProduct}
                      getOptionLabel={option => option.nomProd}
                      onChange={(e, v) => {
                        if (v) {
                          handleChangeValue(v.nomProd);
                        } else {
                          setProduitForm(prev => ({
                            ...prev,
                            nomProd: '',
                            prixProd: 0,
                            codeBarre: ''
                          }));
                          setPrix(0);
                        }
                      }}
                      value={allProduct.find(p => p.nomProd === produitForm.nomProd) || null}
                      renderInput={params => (
                        <TextField 
                          {...params} 
                          label="Produit" 
                          variant="outlined" 
                          fullWidth
                          required 
                        />
                      )}
                    /> 
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Autocomplete
                      id="codeBarre"
                      options={codeBarre}
                      getOptionLabel={option => option.codeBarre}
                      onChange={(e, v) => {
                        if (v) {
                          handleCodeBarre(v.codeBarre);
                        } else {
                          setProduitForm(prev => ({
                            ...prev,
                            codeBarre: '',
                            nomProd: '',
                            prixProd: 0
                          }));
                          setProd('');
                          setPrix(0);
                        }
                      }}
                      value={codeBarre.find(p => p.codeBarre === produitForm.codeBarre) || null}
                      autoHighlight={true}
                      selectOnFocus
                      clearOnBlur
                      renderInput={params => (
                        <TextField 
                          {...params} 
                          label="CodeBarre" 
                          variant="outlined" 
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      name="qtVdu"
                      label='Quantité vendue'
                      type="number"
                      fullWidth
                      variant="outlined"
                      value={produitForm.qtVdu}
                      onChange={(e) => setProduitForm(prev => ({
                        ...prev,
                        qtVdu: parseInt(e.target.value) || 1
                      }))}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      required
                      inputProps={{ min: 1 }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      name="prixProd"
                      label='Prix produit'
                      type="number"
                      fullWidth
                      variant="outlined"
                      value={produitForm.prixProd}
                      onChange={(e) => setProduitForm(prev => ({
                        ...prev,
                        prixProd: parseFloat(e.target.value) || 0
                      }))}
                      required
                      inputProps={{ min: 0, step: "0.01" }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div style={{ 
                      padding: '10px', 
                      background: ajoutAuto ? '#e8f5e8' : '#fff3cd', 
                      borderRadius: '4px',
                      border: `1px solid ${ajoutAuto ? '#4caf50' : '#ffc107'}`
                    }}>
                      <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                        <strong>Info:</strong> {ajoutAuto 
                          ? "La sélection d'un produit l'ajoute automatiquement au panier" 
                          : "Cliquez sur 'Valider' pour ajouter le produit au panier"}
                      </p>
                    </div>
                  </Grid>

                  {!ajoutAuto && (
                    <Grid item xs={12}>
                      <Button 
                        type='submit'
                        style={btnStyle}  
                        variant='contained'
                        fullWidth
                        disabled={!produitForm.nomProd || produitForm.prixProd <= 0 || produitForm.qtVdu <= 0}
                      >
                        Valider
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </form>
            </Container>
          </Grid>
          
          <Grid item xs={8}>
            <MaterialTable 
              columns={columns} 
              data={prodVenduPending}
              editable={{
                onRowUpdate: (newRow, oldRow) => new Promise((resolve) => {
                  CliniqueService.updateProdVendu(newRow, oldRow.idProdVdu)
                    .then((response) => {
                      toast.success("Produit vendu modifié avec succès...", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                      refreshProdVendus();
                    })
                    .catch((error) => {
                      console.log(error);
                      toast.error(error.response?.data, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                    });
                  setTimeout(() => resolve(), 500);
                }),
                onRowDelete: (selectedRow) => new Promise((resolve) => {
                  CliniqueService.deleteProdVendu(selectedRow.idProdVdu)
                    .then((response) => {
                      toast.success("Produit vendu supprimé avec succès...", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                      refreshProdVendus();
                    })
                    .catch((error) => {
                      console.log(error);
                      toast.error(error.response?.data, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                      });
                    });
                  setTimeout(() => resolve(), 1000);
                })
              }}
              options={{
                sorting: true,
                filtering: true, 
                paging: true, 
                pageSizeOptions: [2, 5, 10, 20, 25, 50, 100], 
                pageSize: 5,
                paginationType: "stepped", 
                showFirstLastPageButtons: false, 
                paginationPosition: "both", 
                exportButton: true,
                exportAllData: true, 
                exportFileName: "BON DE COMMANDES", 
                addRowPosition: "first", 
                actionsColumnIndex: -1, 
                selection: true,
                showSelectAllCheckbox: false, 
                showTextRowsSelected: false, 
                selectionProps: rowData => ({
                  color: "primary"
                }),
                columnsButton: true,
                rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
                headerStyle: { background: "#226D68", color: "#fff"},
              }}
              title="Liste des produits à vendre"
              icons={{ Add: () => <AddIcon /> }} 
            />
          </Grid>
        </Grid>
      </div>}

      {/* MODAL DE FACTURE */}
      <Modal
        open={printBillModalVisibility}
        onCancel={() => setPrintBillModalVisibilty(false)}
        title=""
        footer={null}
        width={400}
        style={{ top: 20 }}
        closable={false}
      >
        <div ref={componentRef} style={{ 
          padding: '20px', 
          fontFamily: "'Courier New', monospace",
          background: 'white',
          borderRadius: '8px',
          maxWidth: '380px',
          margin: '0 auto',
          color: 'black',
          border: '1px solid #ddd'
        }}>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '20px',
            borderBottom: '2px solid #000',
            paddingBottom: '15px'
          }}>
            <div style={{
              background: 'white',
              color: 'black',
              padding: '12px',
              borderRadius: '8px 8px 0 0',
              margin: '-20px -20px 15px -20px',
              borderBottom: '1px solid #000'
            }}>
              <h2 style={{ 
                margin: 0, 
                fontSize: '20px',
                fontWeight: 'bold',
                letterSpacing: '1px'
              }}>
                {process.env.REACT_APP_PHARMACY_NAME || "PHARMACIE NDIOL FOUTA"}
              </h2>
            </div>
            
            <div style={{ fontSize: '12px', lineHeight: '1.4', color: '#000' }}>
              <p style={{ margin: '4px 0', fontWeight: 'bold' }}>
                {process.env.REACT_APP_OWNER_NAME || "DR. AL Ousseynou KEITA"}
              </p>
              <p style={{ margin: '3px 0' }}>
                {process.env.REACT_APP_ADDRESS_LINE1 || "Sor Diagne Route Nationale N 2"}
              </p>
              <p style={{ margin: '3px 0' }}>
                {process.env.REACT_APP_ADDRESS_LINE2 || "Saint-Louis - Tél: +221 33 961 08 80"}
              </p>
              {/* <p style={{ margin: '3px 0', fontSize: '10px', color: '#000' }}>
                {process.env.REACT_APP_BUSINESS_INFO || "NINEA:007968079 - RC: SN-STL-2020-A-1225"}
              </p> */}
            </div>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr',
            gap: '10px',
            marginBottom: '15px',
            fontSize: '12px',
            color: '#000'
          }}>
            <div>
              <span style={{ color: '#000' }}>Vendeur:</span>
              <br />
              <strong>{reportPrVendu[0]?.vendeur || "N/A"}</strong>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={{ color: '#000' }}>Facture N°:</span>
              <br />
              <strong>{reportPrVendu[0]?.numFactSrt || "N/A"}</strong>
            </div>
            <div style={{ gridColumn: 'span 2', textAlign: 'center', marginTop: '5px' }}>
              <span style={{ color: '#000' }}>Date:</span>
              <br />
              <strong>{moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</strong>
            </div>
            {modePayement && (
              <div style={{ gridColumn: 'span 2', textAlign: 'center', marginTop: '5px' }}>
                <span style={{ color: '#000' }}>Mode de paiement:</span>
                <br />
                <strong style={{ 
                  color: modePayement === 'ESPECE' ? '#2e7d32' : '#1565c0',
                  fontWeight: 'bold'
                }}>
                  {modePayement}
                </strong>
              </div>
            )}
            {/* Indicateur TVA sur la facture */}
            <div style={{ gridColumn: 'span 2', textAlign: 'center', marginTop: '5px' }}>
              <span style={{ color: '#000' }}>État TVA:</span>
              <br />
              <strong style={{ 
                color: (tvaEnabled && FEATURE_TVA_ENABLED) ? '#4caf50' : '#ff9800',
                fontWeight: 'bold'
              }}>
                {(tvaEnabled && FEATURE_TVA_ENABLED) ? 'AVEC TVA' : 'SANS TVA'}
              </strong>
            </div>
          </div>

          <div style={{ 
            borderTop: '1px dashed #000',
            margin: '15px 0',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              top: '-2px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: 'white',
              padding: '0 10px',
              fontSize: '10px',
              color: '#000',
              fontWeight: 'bold'
            }}>
              DÉTAIL DES ARTICLES
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '3fr 1fr 1fr 1fr',
              gap: '8px',
              padding: '8px 0',
              borderBottom: '2px solid #000',
              fontSize: '11px',
              fontWeight: 'bold',
              color: '#000'
            }}>
              <div>Produit</div>
              <div style={{ textAlign: 'center' }}>Qty</div>
              <div style={{ textAlign: 'right' }}>Prix</div>
              <div style={{ textAlign: 'right' }}>Total</div>
            </div>
            
            {(() => {
              const produits = Array.isArray(reportPrVendu) 
                ? reportPrVendu 
                : (reportPrVendu && typeof reportPrVendu === 'object' ? [reportPrVendu] : []);
              
              return produits.length > 0 ? (
                produits.map((item, index) => (
                  <div key={index} style={{
                    display: 'grid',
                    gridTemplateColumns: '3fr 1fr 1fr 1fr',
                    gap: '8px',
                    padding: '6px 0',
                    borderBottom: '1px solid #ddd',
                    fontSize: '11px',
                    lineHeight: '1.3',
                    color: '#000'
                  }}>
                    <div style={{ wordBreak: 'break-word' }}>{item.nomProd}</div>
                    <div style={{ textAlign: 'center' }}>{item.qtVdu}</div>
                    <div style={{ textAlign: 'right' }}>{item.prixProdVendu?.toLocaleString()}</div>
                    <div style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {((item.prixProdVendu || 0) * (item.qtVdu || 0)).toLocaleString()}
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '20px', 
                  color: '#000',
                  fontSize: '12px'
                }}>
                  Aucun produit dans cette vente
                </div>
              );
            })()}
          </div>

          {/* CALCUL DES TOTAUX AVEC/SANS TVA */}
          {(() => {
            const produits = Array.isArray(reportPrVendu) ? reportPrVendu : [reportPrVendu];
            
            let sousTotal = 0;
            produits.forEach(item => {
              const totalProduit = (item.prixProdVendu || 0) * (item.qtVdu || 0);
              sousTotal += totalProduit;
            });

            const remiseMontant = valueRemise ? (sousTotal * parseFloat(valueRemise)) / 100 : 0;
            const netSansTVA = sousTotal - remiseMontant;
            
            // Vérifier si la TVA était activée
            const tvaActive =  tvaEnabled && FEATURE_TVA_ENABLED;
            
            let tvaSurNet = 0;
            let netAPayer = netSansTVA;
            
            if (tvaActive) {
              tvaSurNet = netSansTVA * (modePayement === 'ESPECE' ? 0.01 : 0.005);
              netAPayer = netSansTVA + tvaSurNet;
            }

            const montantVerseFacture = montantVerse || (modePayement === 'ESPECE' ? netAPayer : 0);
            const monnaieRendueFacture = montantVerseFacture - netAPayer;

            return (
              <>
                <div style={{ 
                  background: 'white',
                  padding: '15px',
                  borderRadius: '6px',
                  marginBottom: '15px',
                  border: '2px solid #000'
                }}>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '2fr 1fr',
                    gap: '8px',
                    fontSize: '12px',
                    marginBottom: '8px',
                    color: '#000'
                  }}>
                    <div>Sous-total:</div>
                    <div style={{ textAlign: 'right' }}>
                      {sousTotal.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                    </div>
                    
                    {valueRemise && parseFloat(valueRemise) > 0 && (
                      <>
                        <div>Remise ({valueRemise}%):</div>
                        <div style={{ textAlign: 'right', color: '#000' }}>
                          -{remiseMontant.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                        </div>
                      </>
                    )}
                    
                    <div style={{ paddingTop: '8px', marginTop: '8px' }}>
                      <strong>{tvaActive ? 'Net hors taxes:' : 'Total après remise:'}</strong>
                    </div>
                    <div style={{ 
                      textAlign: 'right', 
                      paddingTop: '8px', 
                      marginTop: '8px'
                    }}>
                      {netSansTVA.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                    </div>
                    
                    {/* Afficher la TVA seulement si activée */}
                    {tvaActive && (
                      <>
                        <div>TVA ({modePayement === 'ESPECE' ? '1%' : '0.5%'}):</div>
                        <div style={{ textAlign: 'right', color: '#000' }}>
                          +{tvaSurNet.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                        </div>
                      </>
                    )}
                    
                    <div style={{ 
                      borderTop: '2px solid #000', 
                      paddingTop: '8px', 
                      marginTop: '8px',
                      fontWeight: 'bold'
                    }}>
                      <strong>{tvaActive ? 'NET À PAYER (TTC):' : 'TOTAL À PAYER:'}</strong>
                    </div>
                    <div style={{ 
                      textAlign: 'right', 
                      borderTop: '2px solid #000', 
                      paddingTop: '8px', 
                      marginTop: '8px',
                      fontWeight: 'bold',
                      color: '#000',
                      fontSize: '13px'
                    }}>
                      {netAPayer.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                    </div>

                    {/* Section monnaie rendue */}
                    {modePayement === 'ESPECE' && montantVerseFacture > 0 && (
                      <>
                        <div style={{ 
                          paddingTop: '8px', 
                          marginTop: '8px',
                          color: '#2e7d32'
                        }}>
                          <strong>Montant reçu:</strong>
                        </div>
                        <div style={{ 
                          textAlign: 'right', 
                          paddingTop: '8px', 
                          marginTop: '8px',
                          color: '#2e7d32'
                        }}>
                          {montantVerseFacture.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                        </div>

                        {monnaieRendueFacture >= 0 && (
                          <>
                            <div style={{ 
                              paddingTop: '8px', 
                              marginTop: '8px',
                              color: '#2e7d32',
                              fontWeight: 'bold'
                            }}>
                              <strong>Monnaie rendue:</strong>
                            </div>
                            <div style={{ 
                              textAlign: 'right', 
                              paddingTop: '8px', 
                              marginTop: '8px',
                              color: '#2e7d32',
                              fontWeight: 'bold',
                              fontSize: '13px'
                            }}>
                              {monnaieRendueFacture.toLocaleString(undefined, {maximumFractionDigits:2})} F CFA
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  
                  {/* Indicateur TVA en bas de la facture */}
                  <div style={{
                    textAlign: 'center',
                    marginTop: '15px',
                    padding: '8px',
                    fontSize: '10px',
                    color: tvaActive ? '#4caf50' : '#ff9800',
                    borderTop: '1px dashed #ccc',
                    fontStyle: 'italic',
                    backgroundColor: tvaActive ? '#f1f8e9' : '#fff3e0',
                    borderRadius: '4px'
                  }}>
                    {tvaActive 
                      ? `✓ Facture avec TVA - Taux: ${modePayement === 'ESPECE' ? '1%' : '0.5%'}`
                      : '✗ Facture sans TVA - Montants hors taxes'
                    }
                  </div>
                </div>
              </>
            );
          })()}

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '11px',
            color: '#000',
            marginBottom: '15px',
            padding: '8px 12px',
            background: 'white',
            borderRadius: '4px',
            border: '1px solid #000'
          }}>
            <span>Articles vendus:</span>
            <strong>
              {(Array.isArray(reportPrVendu) 
                ? reportPrVendu 
                : [reportPrVendu]
              ).reduce((a, v) => a + (v.qtVdu || 0), 0)}
            </strong>
          </div>

          <div style={{ 
            textAlign: 'center', 
            marginTop: '20px',
            padding: '15px',
            background: 'white',
            color: 'black',
            borderRadius: '6px',
            margin: '20px -20px -20px -20px',
            borderTop: '2px solid #000'
          }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
              MERCI DE VOTRE VISITE
            </div>
            <div style={{ fontSize: '12px' }}>
              {process.env.REACT_APP_PHARMACY_NAME || "PHARMACIE NDIOL FOUTA"}
            </div>
            <div style={{ fontSize: '10px', marginTop: '5px' }}>
              Bonne santé • À bientôt
            </div>
          </div>

          <div style={{ 
            textAlign: 'center', 
            marginTop: '15px',
            padding: '10px',
            fontSize: '9px',
            color: '#000'
          }}>
            <div style={{ marginBottom: '5px' }}>•••••{process.env.REACT_APP_OWNER_NAME}•••••</div>
            Ticket généré électroniquement
          </div>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: '10px', 
          justifyContent: 'center', 
          marginTop: '20px',
          padding: '15px',
          borderTop: '1px solid #ddd'
        }}>
          <Button 
            type="primary" 
            onClick={handleDirectPrint}
            style={{
              background: '#000',
              borderColor: '#000',
              borderRadius: '20px',
              padding: '8px 20px',
              fontWeight: 'bold'
            }}
          >
            🖨️ Imprimer
          </Button>
          <Button 
            onClick={() => setPrintBillModalVisibilty(false)}
            style={{
              borderRadius: '20px',
              padding: '8px 20px',
              borderColor: '#000',
              color: '#000'
            }}
          >
            ✕ Fermer
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default VendreProduits